import { DATE_FORMAT } from "helpers/common";
import React from "react";

const Columns = ({ handleViewHandler }) => [
    {
        dataField: "roundType",
        text: "Round Type",
        formatter: (_, row) => (
            <span className="text-capitalize">
                {row?.roundType ?? "--"}
            </span>
        ),
    },
    {
        dataField: "status",
        text: "Status",
        formatter: (_, row) => (
            <span>
                {row?.status
                    ? row.status.charAt(0).toUpperCase() + row.status.slice(1)
                    : "--"}
            </span>
        ),
    },
    {
        dataField: "disabledType",
        text: "Disable Type",
        formatter: (_, row) => (
            <span>
                {row?.disabledType
                    ? row.disabledType.charAt(0).toUpperCase() + row.disabledType.slice(1)
                    : "--"}
            </span>
        ),
    },
    {
        dataField: "enabledAt",
        text: "Enabled At",
        formatter: (_, row) => (
            <span className="text-capitalize">
                {row?.enabledAt ? DATE_FORMAT(row.enabledAt) : "--"}
            </span>
        ),
    },
    {
        dataField: "disabledAt",
        text: "Disabled At",
        formatter: (_, row) => (
            <span className="text-capitalize">
                {row?.disabledAt ? DATE_FORMAT(row.disabledAt) : "--"}
            </span>
        ),
    },
    {
        text: "Action",
        dataField: "action",
        formatter: (_, row) => (
            <button
                className="fas fa-eye"
                style={{
                    fontSize: "16px",
                    backgroundColor: "#fff",
                    border: "none",
                }}
                title="View" // ✅ fixed
                onClick={() => handleViewHandler(row)}
            />
        ),
    },
];

export default Columns;